/**
 * Route for `salesforce-hubspot-crm-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SalesforceHubspotCrmIntegrationPage } from "../features/salesforce-hubspot-crm-integration/SalesforceHubspotCrmIntegrationPage";

export const salesforceHubspotCrmIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/salesforce-hubspot-crm-integration",
	component: SalesforceHubspotCrmIntegrationPage,
});

export default salesforceHubspotCrmIntegrationRoute;
